export const payloadShopComSite:any = {
  locale: "en_US",
  publisherId: "AP1701813",
  site: "shop",
  vendor_id: "shop.com",
  perPage: "20",
  start: 0
};

export const payloadIsotonixSite:any = {
  publisherId: "AP1701813",
  site: "isotonix",
  start: 0,
  perPage: "20",
  locale: "en_US",
  vendor_id: "shop.com",
};

export const payloadTransitionsSite:any = {
  publisherId: "AP1701813",
  site: "transitions",
  start: 0,
  perPage: "20",
  locale: "en_US",
  vendor_id: "shop.com",
};

export const payloadMotivesSite:any = {
  publisherId: "AP1701813",
  site: "motives",
  start: 0,
  perPage: "20",
  locale: "en_US",
  vendor_id: "shop.com",
};

export const payloadLumiereSite:any = {
  publisherId: "AP1701813",
  site: "lumiere",
  start: 0,
  perPage: "20",
  locale: "en_US",
  vendor_id: "shop.com",
};

export const payloadLayeredSite:any = {
  publisherId: "AP1701813",
  site: "layered",
  start: 0,
  perPage: "20",
  locale: "en_US",
  vendor_id: "shop.com",
};

export const payloadNatrixSite:any = {"publisherId":"AP1701813","site":"nutrametrix","start":0,"perPage":"20","locale":"en_US","vendor_id":"shop.com","brandId":"nutraMetrix%26reg;"};